<template>
  <v-container class="pr-0 pl-0" fluid>
    <v-stepper vertical>
      <v-stepper-step v-for="item in eventosList" :key="item.id" :step="item.dia" complete>
        <v-card class="elevation-0" dense outlined>
          <v-img
              class="white--text align-end"
              height="200px"
              width="300px"
              :src="item.imagem"
              gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
            >
          <v-card-title class="body-1 justify-start font-weight-bold">
            {{item.nome}}, {{item.data}}
          </v-card-title>
          <v-card-subtitle class="white--text caption">
            {{item.texto}}
          </v-card-subtitle>
          
          </v-img>
          <v-card-actions class="justify-end">
            <v-btn fab dark x-small primary >
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
            <v-btn fab dark x-small primary >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-stepper-step>
    </v-stepper>
  </v-container>
</template>

<script>

import Eventos from "../fake-data/Eventos";

export default {
  props: {
    source: String
  },
  data: () => ({

    eventosList: Eventos.EVENTOS,
  })
};
</script>